import React from 'react';
import { useTranslation } from 'react-i18next';

import { SunManager } from '../../../../../../viewer/sun-manager';
import { useNonce } from '../../../../../hooks/use-nonce';
import { WrapWithSettingsIcon } from '../../settings/wrap-with-settings-icon';
import { ToolIcon } from '../../tool-icon';
import { LightSettings } from './light-settings';

type Props = {
  toolbarRef: React.RefObject<HTMLDivElement>;
};

const LightToolIcon = (props: Props) => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  return (
    <WrapWithSettingsIcon
      content={<LightSettings />}
      toolbarRef={props.toolbarRef}
      tooltip={{
        title: t('light.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('light.settings.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    >
      <ToolIcon
        active={SunManager.instance.isDirectionEnabled()}
        callback={() => {
          SunManager.instance.toggleDirectionLight(!SunManager.instance.isDirectionEnabled());
          refresh();
        }}
        icon={['fal', 'lightbulb']}
        tooltip={{
          title: t('light.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('light.tooltip.text', { ns: 'skyviewToolbar' }),
        }}
      />
    </WrapWithSettingsIcon>
  );
};

export { LightToolIcon };
